export enum ApiStatus {
  Success = 'success',
  Failure = 'failure',
}

export enum LoadingStatus {
  Idle = 'idle',
  Loading = 'loading',
}

export enum ApiStatusMessage {
  Success = 'Your request has been submitted',
  Failure = 'Your request failed to submit, please try again',
}

export const formHeading = 'Your e-mail'
export const formDesc =
  'To opt out of our processing your personal information in this way, please provide your email address:'
export const submitBtnText = 'Submit'
